import { registerMutation, useMutation } from 'data-fetching-client';
import { sendFeedbackRpc } from '../../../__generated__/chirp/com/hubspot/learning/center/search/rpc/SearchChirpService';
import { keepAliveChirpClient } from '../../utils/keepAliveChirpClient';
const SEND_FEEDBACK_MUTATION_KEEP_ALIVE_FIELD_NAME = 'sendFeedbackMutationKeepAlive';
const SEND_FEEDBACK_QUERY = registerMutation({
  fieldName: SEND_FEEDBACK_MUTATION_KEEP_ALIVE_FIELD_NAME,
  args: ['contentContainerType', 'correlationId', 'resultMLOptionId'],
  fetcher(request) {
    return keepAliveChirpClient.call(sendFeedbackRpc, {
      request
    });
  }
});
export const useSearchFeedback = () => useMutation(SEND_FEEDBACK_QUERY);